import axios from '@/axios';

export default {
  namespaced: true,
  state() {
    return {
      logs: [],
      totalLogs: 0,
      currentPage: 1,
      entryLimit: 10,
    };
  },
  mutations: {
    setLogs(state, logs) {
      state.logs = logs;
    },
    setTotalLogs(state, total) {
      state.totalLogs = total;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setEntryLimit(state, limit) {
      state.entryLimit = limit;
    },
  },
  actions: {
    getLogs({ commit }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get('sales-and-purchase/drcc/get-log', {
            params: {
              entry: params.entry || 10,
              page: params.page || 1,
              level: params.level || '',
              message: params.message || '',
              transactionID: params.transactionID || '',
              timestamp: params.timestamp || '',
              service: params.service || '',
              search: params.search || '',
            },
          })
          .then((response) => {
            const { data, total, page, entry } = response.data;
            commit('setLogs', data);
            commit('setTotalLogs', total);
            commit('setCurrentPage', page);
            commit('setEntryLimit', entry);
            resolve(response.data);
          })
          .catch((error) => {
            console.error('Failed to fetch logs:', error);
            reject(error);
          });
      });
    },
  },
};
